// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAccountForm_wrapper__A4HEC","submitWrapper":"EditAccountForm_submitWrapper__X-U5O"};